export default {
  "header": {
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sur"])},
    "log": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion / S'inscrire"])},
    "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se déconnecter"])},
    "manage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faire en sorte"])},
    "music": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La musique"])}
  },
  "home": {
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" Commencez à écouter les meilleures nouveautés."])},
    "listen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Écoutez de la bonne musique !"])}
  },
  "mainContent": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chansons"])}
  },
  "mySongs": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mes chansons"])}
  },
  "sondDetails": {
    "comments": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["No commentaires"]), _normalize(["1 Commenter"]), _normalize([_interpolate(_named("count")), " commentaires"])])}
  },
  "upload": {
    "drop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déposez vos fichiers ici"])},
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Télécharger"])}
  }
}